import { createContractRequest } from './helper';
export const getOfferByPolicy = createContractRequest({
    route: '/contract/offers/policy/:policyNo',
    method: 'get',
    source: 'data',
});
